import React from 'react'
import { Player } from "@lottiefiles/react-lottie-player";

export default function HeroImage() {
  return (
    <div>
            <Player
        autoplay
        loop
        src="https://assets6.lottiefiles.com/packages/lf20_bpqri9y8.json"
        // src="https://assets8.lottiefiles.com/packages/lf20_mragdxra.json"
        // src="https://assets1.lottiefiles.com/packages/lf20_gQsH4V.json"
      >
      </Player>
    </div>
  )
}
